<template>
  <div style="background: white">
    <EducationHeader />
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
        <a-breadcrumb-item @click="onBackLevel" style="cursor:pointer">产业智库</a-breadcrumb-item>
        <a-breadcrumb-item>产业智库详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="tutorBox">
      <div class="logo">
        <img v-if="zhikuDetail.userLogo" style="width: 100%;height: 100%;" :src="getImg(zhikuDetail.userLogo)" />
        <img v-else src="@/assets/img/defaultImg.png" alt="">
      </div>
      <div class="rightBox">
        <div class="tankName">{{ zhikuDetail.thinkTankName }}</div>
        <div class="infoBox">
          <p>地址：{{ zhikuDetail.provject }}{{ zhikuDetail.detailedAddress }}</p>
          <p>会员信息部：{{ zhikuDetail.memberInformationDepartment }}</p>
          <p>传真：{{ zhikuDetail.fax }}</p>
          <p>网址：{{ zhikuDetail.webAddress }}</p>
        </div>
      </div>
    </div>
    <div class="talentBox">
      <div class="talentLeftBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            智库简介
          </div>
        </div>
        <div class="talentContentBox">
          <div class="tutorText" v-html="zhikuDetail.aboutThinkTank"></div>
        </div>
      </div>
    </div>
    <div class="talentBox">
      <div class="talentLeftBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            专家工作站
          </div>
        </div>
        <div class="talentContentBox" v-if="zhikuDetail.talentExpertList && zhikuDetail.talentExpertList.length > 0">
          <div class="zhuanjiaBox" v-for="item in zhikuDetail.talentExpertList" :key="item.id">
            <div class="tutorName">{{ item.name }} / {{ item.duty }}</div>
            <div class="grayBox">
              <a-descriptions :column="3">
                <a-descriptions-item label="职称">{{ item.professionalTitle }}</a-descriptions-item>
                <a-descriptions-item label="研究领域" :span="2">
                  <dict-render :dict-obj="dictObjs['research_field']" v-if="item.industry"
                    :text="item.industry"></dict-render>
                </a-descriptions-item>
              </a-descriptions>
            </div>
            <div class="jianjie">{{ item.personalProfile }}</div>
          </div>
        </div>
      </div>
    </div>
    <LayoutFooter />
  </div>
</template>
<script>
import { dictMixin } from "@/mixins";
import EducationHeader from './educationHeader';
import { homeEducationInfo } from "@/api/educationService";
import DictRender from '@/components/other/DictRender';
import { file_service } from "@/api/adminService";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import { showCity } from "@/utils/util";

export default {
  name: "noticeDetail",
  components: { EducationHeader, DictRender, LayoutFooter },
  mixins: [dictMixin],
  data() {
    return {
      dictNames: 'education_background,professionalTitle,research_field',
      zhikuDetail: {}
    }
  },
  methods: {
    getDetail() {
      this.getAction({
        url: homeEducationInfo.zhikuDetail,
        params: { id: this.$route.query.id }
      }).then(res => {
        let obj = {
          ...res,
          provject: showCity(res.prov, res.city, res.dist),
        }
        this.zhikuDetail = obj
      })
    },
    onBackLevel() {
      this.$router.push({
        path: "/educationService/components/thinktank",
        query: { type: '产业智库' }
      })
    },
    onRollbackHome() {
      this.$router.push({
        path: "/educationService/index",
        query: { type: '首页' }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
  },
  mounted() {
    this.getDetail()
  }
}
</script>
<style lang="less" scoped>
.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  background: white;
}

.tutorBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px;

  .logo {
    float: left;
    width: 400px;
    height: 225px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .rightBox {
    float: left;
    margin-left: 15px;
    padding: 15px 0;

    .tankName {
      margin-bottom: 15px;
      font-size: 18px;
      color: #333;
    }

    .infoBox {
      font-size: 14px;
      color: #666;

      p {
        margin: 10px 0;
      }
    }
  }
}

.talentBox {
  overflow: hidden;
  width: 1200px;
  margin: 20px auto;

  .talentLeftBox {
    width: 100%;

    .talentTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      border-bottom: 1px solid #dedede;

      .talentTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .talentTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #035aea;
      }
    }

    .talentContentBox {
      padding: 14px 0;
      width: 100%;

      .tutorText {
        font-size: 14px;
        color: #333;
        text-indent: 2em;
      }

      .zhuanjiaBox {
        width: 1200px;
        margin: 0 auto;
        padding: 20px;
        border-bottom: 1px dashed #dedede;

        .tutorName {
          margin-bottom: 10px;
          font-size: 16px;
          color: #333;
        }

        .grayBox {
          margin-bottom: 10px;
          font-size: 14px;
          color: #999;
        }
        .jianjie{
          text-indent: 2em;
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}

:deep(.ant-descriptions-item) {
  padding-bottom: 6px;
}

:deep(.ant-descriptions-item-label) {
  font-size: 14px;
  color: #999;
}

:deep(.ant-descriptions-item-content) {
  font-size: 14px;
  color: #999;
}
</style>
